<div [class]="{ 'px-sm-3': !suppressUI, 'px-md-4': !suppressUI }" class="ms-sm-auto py-2 font-size-sm">
  <div  [class.d-none]="suppressUI" class="mb-2">{{ dateFilterVerbiage }} <small>(default is current {{duration}} days)</small></div>
  <form #dateFilterForm="ngForm">
    <label class="me-5">
      From:
      <p-calendar #from name="startDate" [(ngModel)]="dateRangeFilterModel.startDate" [showIcon]="true" [yearRange]="yearRange" [monthNavigator]="true" [yearNavigator]="true" selectionMode="single" inputStyleClass="form-control" styleClass="mb-2"></p-calendar>
    </label>
    <label>
      To:
      <p-calendar #to name="endDate" [(ngModel)]="dateRangeFilterModel.endDate" [showIcon]="true" [yearRange]="yearRange" [monthNavigator]="true" [yearNavigator]="true" selectionMode="single"  inputStyleClass="form-control" styleClass="mb-2"></p-calendar>
    </label>
  </form>
</div>
